export default __webpack_public_path__ + "static/our-mission-e3c3bf630cf91efa0ad4a5aab31e8070.webp";